import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import { DataTable } from "../../../common/DataTable";
import { TAX_NUMBERS } from "../../../../utils/data/models";
import { INSURANCE } from "./taxNameTypes";
import * as dataActions from "../../../../utils/data/dataActions";

class TaxesDataTable extends React.Component {
    constructor(props, context) {
      super(props, context);
    
      this.getData = this.getData.bind(this);
      this.getTaxName = this.getTaxName.bind(this);
    }
    
    componentWillMount() {
      this.props.dataActions.clearDataList(TAX_NUMBERS);
    }

    getTaxName(tax) {
      if (tax.taxName != INSURANCE.value) {
        return tax.taxName;
      }

      const userLanguage = localStorage.getItem("languageCode");
      return <span><FormattedMessage id="admin.taxes.datatable.taxTypes.insurance"/> {tax.province.localizations[userLanguage].name.toUpperCase()}</span>;
    }
    
    getData(offset, limit, q, sortBy, filters) {
        this.props.dataActions.getDataList(
            TAX_NUMBERS,
            offset,
            limit,
            q,
            sortBy,
            filters
        );
    }
    
    getCols() {
        return [
            {
                name: (
                  <FormattedMessage id="admin.taxes.datatable.columns.taxName" />
                ),
                display: (tax) => (
                  this.getTaxName(tax)
                ),
                widthPct: 50,
              },
              {
                name: (
                  <FormattedMessage id="admin.taxes.datatable.columns.taxNumber" />
                ),
                display: (tax) => (
                  <span>
                    {tax.number}
                  </span>
                ),
                widthPct: 50,
              },
        ];
    }
    
    render() {
        return (
          <div>
            <div className="justify-title-header">
              <FormattedMessage id="admin.taxes.subTitle" />
            </div>
            <DataTable
              ref="dataTable"
              title={<FormattedMessage id="admin.taxes.title" />}
              getData={this.getData}
              cols={this.getCols()}
              q={this.props.q}
              filters={this.props.filters}
              offset={this.props.offset}
              data={this.props.items}
              rowsPerPage={this.props.limit}
              totalRows={this.props.total}
              sortBy={this.props.sortBy}
              showFilters={false}
            />
          </div>
        );
    }
}

TaxesDataTable.propTypes = {
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  items: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  q: PropTypes.string,
  sortBy: PropTypes.array,
  total: PropTypes.number,
};


function mapStateToProps(state) {
    const data = state.data.taxNumbers || {};
    const pagination = data.pagination || {};
    
    return {
      active: data.active || {},
      authLanguageCode: state.auth.user.languageCode,
      limit: pagination.limit || 100,
      offset: pagination.offset || 0,
      sortBy: data.sortBy || ["taxName:asc"],
      q: data.q || 0,
      filters: data.filters || [""],
      total: pagination.totalCount || 0,
      items: data.items || null,
    };
  }


  function mapDispatchToProps(dispatch) {
    return {
      dataActions: bindActionCreators(dataActions, dispatch),
    };
  }

  
export default connect(mapStateToProps, mapDispatchToProps)(TaxesDataTable);


// WEBPACK FOOTER //
// ./src/components/dashboard/admin/taxes/TaxesDataTable.js